
export const SITE_NAME = "Childreams Studio";
export const SITE_URL = "https://childreamsstudio.com";

export const DEFAULT_META = {
  title: SITE_NAME,
  desc: "Childreams Studio adalah studio kreatif yang berfokus pada pengembangan konten edukatif untuk anak-anak.",
  keywords: "childreams, karakter, animasi, buku anak, konten edukasi, anak indonesia",
  image: "/assets/logo-box.jpg",
};

export const URLS = {
  home: {
    path: "/",

    image: "%PUBLIC_URL%/assets/logo.png",
    title: "Childreams Studio",
    desc: "Childreams Studio adalah studio kreatif yang berfokus pada pengembangan konten edukatif untuk anak-anak.",
    keywords: "childreams, karakter, animasi, buku anak, konten edukasi, anak indonesia",
    metaImage: "/assets/logo-box.jpg",
  },
  siKembarPintar: {
    path: "/universe/si-kembar-pintar",
    title: "Si Kembar Pintar",
    desc: "Ikuti petualangan seru Dre dan Amy, si kembar pintar bersama Roboling! Pecahkan masalah, pelajari nilai Islam, dan saksikan persahabatan mereka bersama Ayah, Ibu, dan Pena.",
    keywords: "si kembar pintar, dre, amy, roboling, ayah, ibu, pena, karakter, animasi, buku anak, konten edukasi, anak indonesia",
    metaImage: "/assets/images/banner-kembar.jpg",
  },
  jejakRejakids: {
    path: "/in-progress",
  },
  bira: {
    path: "/in-progress",
  },
  adventureOfCimiCimo: {
    path: "/in-progress",
  },
  gani: {
    path: "/in-progress",
  },
  storyBook: {
    path: "/products/story-book",
    title: "Buku Cerita",
    desc: "Buku cerita anak dari Childreams Studio dengan ilustrasi menarik, aman, dan penuh nilai kebaikan.",
    keywords: "buku cerita anak, childreams, ilustrasi anak, konten edukasi, buku anak indonesia",
    metaImage: "/assets/logo-box.jpg",
  },
  activityBook: {
    path: "/in-progress",
  },
  animation: {
    path: "/in-progress",
  },
  merchandise: {
    path: "/in-progress",
  },
  about: {
    path: "/about",
    title: "Tentang Kami",
    desc: "Kenali Childreams Studio, studio kreatif pengembang konten edukatif anak dengan karakter orisinil.",
    keywords: "tentang childreams, studio kreatif anak, konten edukasi anak, karakter orisinil",
    metaImage: "/assets/logo-box.jpg",
  },
  contact: {
    path: "/contact",
    title: "Kontak",
    desc: "Hubungi Childreams Studio untuk kolaborasi, lisensi karakter, atau peluang reseller.",
    keywords: "kontak childreams, kolaborasi, lisensi karakter, reseller buku anak",
    metaImage: "/assets/logo-box.jpg",
  },
  lang: {
    path: "/lang",
  },
  writingClass: {
    path: "/writing-class",
  },
};

export const getPath = (item) => {
  if (!URLS[item]) {
    throw new Error(`Invalid route key: "${item}" does not exist in URLS`);
  }
  return URLS[item].path;
};
